import React from 'react'
import PropTypes from 'prop-types'

import { Box } from '@material-ui/core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-solid-svg-icons'

import { ComposeActionTrigger as BaseActionTrigger } from 'components/ComposeOutreachMessageButton/Triggers'

export const ComposeActionTrigger = ({ trigger }) => (
  <BaseActionTrigger
    trigger={trigger}
    size="large"
  >
    <FontAwesomeIcon
      icon={faPlus}
      aria-hidden
    />
    <Box
      component="span"
      pl={1.5}
    >
      New Message
    </Box>
  </BaseActionTrigger>
)

ComposeActionTrigger.propTypes = {
  trigger: PropTypes.string.isRequired,
}
